import { PrineConvertAdapterOptions } from '../types/PrineConvertAdapterOptions';
import { PrineConvertAdapter } from '../PrineConvertAdapter';
import { PrineConvertAdapterExport } from '../PrineConvertAdapterExport';
import { PrineConvertExportData } from '../types/PrineConvertExportData';
import { PrineConvertImportData } from '../types/PrineConvertImportData';
import { PrineConvertAdapterImport } from '../types/PrineConvertAdapterImport';

// tslint:disable-next-line:variable-name
export const PrineConvertAdapterCSVOptionsPreset_TabSeperated: Partial<PrineConvertAdapterCSVOptions> = {
    mimeType: 'text/tsv',
    linebreak: '\n',
    enclosedBy: '',
    escapeEnclosedBy: '\\',
    delimiter: '\t',
};

export interface PrineConvertAdapterCSVOptions extends PrineConvertAdapterOptions {
    linebreak: string;
    enclosedBy: string;
    escapeEnclosedBy: string;
    delimiter: string;
    truthyBoolValue: string;
    falsyBoolValue: string;
}

export class PrineConvertAdapterCSV extends PrineConvertAdapter {
    options: PrineConvertAdapterCSVOptions = {
        mimeType: 'text/csv',
        linebreak: '\n',
        enclosedBy: '"',
        escapeEnclosedBy: '\\',
        delimiter: ',',
        truthyBoolValue: 'Yes',
        falsyBoolValue: 'No',
    };

    casts = {
        null: () => '',
        bool: (value: any) => (value ? this.options.truthyBoolValue : this.options.falsyBoolValue),
        array: (value: any) => value.join(', '),
        object: (value: any) =>
            Object.entries(value)
                .map(([key, _]) => `${key}: ${_}`)
                .join('; '),
    };

    constructor(options?: Partial<PrineConvertAdapterCSVOptions>) {
        super();
        this.options = { ...this.options, ...options };

        if (options && options.casts) {
            this.casts = { ...this.casts, ...options.casts };
        }
    }

    export(data: PrineConvertExportData): PrineConvertAdapterExport[] {
        const options = this.options;

        const enclose = (value: any) => this.options.enclosedBy + value + this.options.enclosedBy;
        const escape = (value: any) => {
            if (value && typeof value === 'string') {
                value = value.replaceAll(
                    this.options.enclosedBy,
                    this.options.escapeEnclosedBy + this.options.enclosedBy
                );
            }

            return value;
        };

        return data
            .map((container) => this.castValues(container))
            .map((container) =>
                [
                    container.fields.map(this.getFieldLabel).map(escape).map(enclose).join(this.options.delimiter),
                    ...container.rows.map((row) =>
                        Object.values(row).map(escape).map(enclose).join(this.options.delimiter)
                    ),
                ].join(this.options.linebreak)
            )
            .map((rows) => {
                return new (class extends PrineConvertAdapterExport {
                    constructor() {
                        super(options);
                    }

                    asRaw() {
                        return rows;
                    }
                })();
            });
    }

    import(data: PrineConvertImportData): PrineConvertAdapterImport[] {
        return [];
    }
}
